import { ErrorAlert } from '../shared/icons/ErrorAlert'
import { Banner } from './Banner'

type ErrorProps = {
  title: string
  children: string
  handleClose?(): void
}

const NotificationsError = ({ title, children, handleClose }: ErrorProps) =>
  <Banner
    title={title}
    handleClose={handleClose}
    textColor="#412200"
    borderColor='#EF7A00'
    backgroundColor='#FEF8F2'
    flag={<ErrorAlert />}
  >
    {children}
  </Banner>

export { NotificationsError }
